import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  accordion: {
    overflow: 'hidden',
    border: "1px solid transparent",
    '&.Mui-expanded': {
      margin: '0'
    },
    '& + &': {
      marginTop: '10px'
    },
    '& .MuiAccordionSummary-root': {
      flexDirection: 'initial',
      padding: '12px 16px',
      boxShadow: palette.shadows.light
    },
    '& .MuiAccordionSummary-content': {
      display: 'flex',
      alignItems: 'center',
      marginRight: '20px'
    },
    '& .MuiAccordionDetails-root': {
      padding: '16px'
    },
    '& .MuiFormControlLabel-root': {
      marginRight: '0',
      marginLeft: '0'
    },
    '& .MuiAccordionSummary-expandIconWrapper': {
      transform: 'rotate(90deg)',
      '&.Mui-expanded': {
        transform: 'rotate(-90deg)'
      }
    }
  },
  utilityDisabled: {
    backgroundColor: palette.shades[200],
    boxShadow: 'none',
    border: "1px solid ".concat(palette.shades[300]),
    '& .MuiAccordionSummary-expandIconWrapper svg path': {
      fill: palette.shades[400]
    }
  },
  accordionDisabled: {
    backgroundColor: palette.shades[200],
    boxShadow: 'none',
    border: "1px solid ".concat(palette.shades[300]),
    '& .MuiAccordionSummary-expandIconWrapper svg path': {
      fill: palette.shades[600]
    }
  },
  listItem: {
    border: "1px solid ".concat(palette.shades[300]),
    borderRadius: '2px',
    padding: '8px',
    '& + &': {
      marginTop: '4px'
    }
  },
  listItemAlerts: {
    margin: '8px -8px -8px -8px',
    '& .MuiAlert-root': {
      padding: '8px'
    }
  },
  listItemActive: {
    backgroundColor: palette.shades[100]
  },
  listItemContent: {
    display: 'flex',
    minHeight: '36px',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  flex: {
    display: 'flex',
    alignItems: 'center'
  },
  accorionUtilityContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    marginRight: '20px'
  },
  listItemText: {
    display: 'flex',
    alignItems: 'center'
  },
  listItemTextIcon: {
    margin: '0 10px'
  },
  utilityIcon: {
    margin: '0 10px',
    backgroundColor: palette.shades[200],
    borderRadius: '2px',
    padding: '12px'
  },
  utilityWrapper: {
    display: 'flex',
    alignItems: 'center'
  },
  infoBlock: {
    backgroundColor: palette.info.light,
    borderRadius: '2px',
    padding: '5px 10px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& .MuiSvgIcon-root': {
      marginRight: '4px'
    }
  },
  hidden: {
    display: 'none'
  },
  customUtilityField: {
    width: '320px',
    marginRight: '10px'
  },
  listItemError: {
    borderColor: palette.error.main
  },
  warningValue: {
    color: palette.warning.main
  },
  listItemDetails: {
    padding: '8px',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#e4f0fc',
    margin: '8px -8px -8px -8px',
    justifyContent: 'space-between'
  },
  editableForm: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& .MuiTypography-root': {
      whiteSpace: 'nowrap',
      marginRight: '4px'
    },
    '& .MuiFormControl-root': {
      maxWidth: '100px'
    }
  }
});
export default useStyles;